import $ from "jquery";
/* eslint-disable */
export const magicZoomControls = () => {

  $(document).ready(function () {
    $(".swiper-button-next").on("click",()=>{
        MagicZoom.next('mobile-zoom');
    });

    $(".swiper-button-prev").on("click",()=>{
        MagicZoom.prev('mobile-zoom');
    });


  });
};
